import React from 'react'

export const CustomizeRequiredMark = (
  label: React.ReactNode,
  { required }: { required: boolean },
) => (
  <>
    {label}
    {required && <span className="ml-1 text-red-500">*</span>}
  </>
)
